export const EVENTO_MANIFESTACAO = {
  CIENCIA_OPERACAO: 1,
  CONFIRMACAO_OPERACAO: 2,
  DESCONHECIMENTO_OPERACAO: 3,
  OPERACAO_NAO_REALIZADA: 4
};
